import { ContentCopy } from '@mui/icons-material'
import {
  IconButton,
  InputAdornment,
  SxProps,
  TextField,
  Tooltip,
} from '@mui/material'
import { useState } from 'react'

import useT from '@/i18n/useT'

function CopyableField({
  label,
  value,
  sx,
}: {
  label: string
  value: string
  sx?: SxProps
}) {
  const { t } = useT()
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 3000)
  }

  return (
    <TextField
      label={label}
      value={value}
      fullWidth
      sx={sx}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip
              title={copied ? t('common.copied') : t('common.copy', { label })}
              arrow
              placement="top"
            >
              <IconButton onClick={handleCopy}>
                <ContentCopy fontSize="small" />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default CopyableField
